// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2xaaW","container":"styles_container__2ATXU","title":"styles_title__1Kq2M","wrapper":"styles_wrapper__1za2E","answer":"styles_answer__2yjFk"};